// Title animate text

export default class TitleAnimateTxt {
    constructor() {
        this.ui = this.getUI();
        this.listen();
    }

    getUI() {
        return {
            titleAnimate: document.querySelectorAll(".animate-title__content"),
            txtOne: document.querySelector(".txt-animate-1"),
            txtTwo: document.querySelector(".txt-animate-2"),
            txtThree: document.querySelector(".txt-animate-3"),
            thedelay: 2500 // Délai d'attente entre chaque texte
        }
    }

    listen() {
        if(this.ui.titleAnimate.length > 0) { // Lancement de l'animation sur les 3 textes
            this.animateTxt1(0);
        }
    }

    animateTxt1(delay) { // Paramètres mis en place sur les 3 textes en temps 1
        const that = this;
        setTimeout(function() {
            that.ui.txtOne.style.display = "inline";
            that.ui.txtTwo.style.display = "none";
            that.ui.txtThree.style.display = "none";
            that.animateTxt2(that.ui.thedelay);
        }, delay);
    }

    animateTxt2(delay) { // Paramètres mis en place sur les 3 textes en temps 2
        const that = this;
        setTimeout(function() {
            that.ui.txtOne.style.display = "none";
            that.ui.txtTwo.style.display = "inline";
            that.ui.txtThree.style.display = "none";
            that.animateTxt3(that.ui.thedelay);
        }, delay);
    }

    animateTxt3(delay) { // Paramètres mis en place sur les 3 textes en temps 3
        const that = this;
        setTimeout(function() {
            that.ui.txtOne.style.display = "none";
            that.ui.txtTwo.style.display = "none";
            that.ui.txtThree.style.display = "inline";
            //that.animateTxt1(that.ui.thedelay);
        }, delay);
    }
}